import { t } from "../../../services/utils";
import React, { Component } from "react";
import FileChip from "../../../components/FileChip";
class FilesView extends Component {
  render() {
    let styles = {
      container: {
        backgroundColor: "white",
        paddingLeft: 16,
        paddingRight: 16,
        display: "flex",
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
        height: "100%",
      },
      attachmentsContainer: {
        display: "flex",
        width: "100%",
        flexWrap: "wrap",
      },
      fileChip: {
        // width: "44%",
        maxWidth: 180,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 0,
      },
    };
    const files = this.props.files;
    return (
      <div style={styles.container} data-testid="story-files">
        {files.length > 0 && (
          <div
            style={styles.attachmentsContainer}
            className="attachments-container"
          >
            {files.map((fileInfo, index) => (
              <FileChip
                key={fileInfo.url}
                name={fileInfo.name}
                url={fileInfo.url}
                style={styles.fileChip}
                handleRequestDelete={(e) => {
                  e.stopPropagation();
                  this.handleRequestDelete(index);
                }}
                downloadable
              />
            ))}
          </div>
        )}
      </div>
    );
  }
  static getHeight(props) {
    const { files } = props;
    const filesHeight = Math.ceil(files.length / 2) * 76;
    return filesHeight;
  }
}
export default FilesView;
